export enum CardSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg'
}

export type CssClassMap = { [className: string]: boolean };
